import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import {
  createStateSyncMiddleware,
  initMessageListener,
} from 'redux-state-sync';
import { advancedAccessKeySlice } from './slice/advancedAccesskeySlice';
import { standardAccessKeySlice } from './slice/standardAccessKeySlice';
import { resumeSlice } from './slice/resumeSlice';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['advancedAccessKey', 'standardAccessKey'],
  version: 1,
  debug: true,
};

const rootReducer = combineReducers({
  advancedAccessKey: advancedAccessKeySlice.reducer,
  standardAccessKey: standardAccessKeySlice.reducer,
  resume: resumeSlice.reducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

// https://github.com/rt2zz/redux-persist/issues/988
// こちらを参考に「persist」キーの「serializable」のチェックを無視
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }).concat(
      createStateSyncMiddleware({
        blacklist: [
          'persist/PERSIST',
          'persist/REHYDRATE',
          'resume/saveSentenceId',
          'resume/saveTrainingId',
        ],
      }),
    ),
});

initMessageListener(store);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export const useAppDispatch = (): AppDispatch => useDispatch<AppDispatch>();
export default store;
